/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSS, getCSSVariableValue} from '@metronic/assets/ts/_utils'
import {useThemeMode} from '@metronic/partials/layout/theme-mode/ThemeModeProvider'
import {useIntl} from "react-intl";
import {NumReplace} from "@utils/index";

import { DatePicker, Space } from 'antd';
import moment from "moment";


type Props = {
    className: string
    data: any
}

const ChartsWidget: React.FC<Props> = ({className, data}) => {
    const chartRef = useRef<HTMLDivElement | null>(null)
    const {mode} = useThemeMode()
    const intl = useIntl()


    const refreshMode = () => {
        if (!chartRef.current) {
            return
        }

        const height = parseInt(getCSS(chartRef.current, 'height'))

        const chart = new ApexCharts(chartRef.current, getChartOptions(height, data))
        if (chart) {
            chart.render()
        }

        return chart
    }

    useEffect(() => {
        const chart = refreshMode()

        return () => {
            if (chart) {
                chart.destroy()
            }
        }
    }, [chartRef, mode])

    return (
        <div className={`card ${className}`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>{intl.formatMessage({id: 'DASHBOARD_CHART_TITLE'})}</span>
                </h3>


            </div>
            {/* end::Header */}

            {/* begin::Body */}
            <div className='card-body'>
                {/* begin::Chart */}
                <div ref={chartRef} id='kt_charts_widget_3_chart' style={{height: '350px'}}></div>
                {/* end::Chart */}
            </div>
            {/* end::Body */}
        </div>
    )
}

export {ChartsWidget}

interface IpropsWidget  {
    series: any[],
    categories: string[]
}

function getChartOptions(height: number, data:IpropsWidget): ApexOptions {
    const labelColor = getCSSVariableValue('--kt-gray-500')
    const borderColor = getCSSVariableValue('--kt-gray-200')
    const successColor = getCSSVariableValue('--kt-success')
    const dangerColor = getCSSVariableValue('--kt-primary')
    const warningColor = getCSSVariableValue('--kt-info')
    const successColor1 = getCSSVariableValue('--kt-success-light')
    const dangerColor2 = getCSSVariableValue('--kt-primary-light')
    const warningColor3 = getCSSVariableValue('--kt-info-light')

    return {
        series: data?.series||[],

        chart: {
            fontFamily: 'inherit',
            type: 'line',
            height: 350,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {},
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false,
        },
        fill: {
            type: 'solid',
            opacity: 1,
        },

        stroke: {
            curve: 'smooth',
            show: true,
            width: 3,
            colors: [successColor, dangerColor, warningColor],
        },
        xaxis: {
            categories: data?.categories||[],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
            crosshairs: {
                position: 'front',
            },
            tooltip: {
                enabled: true,
                formatter: undefined,
                offsetY: 0,
                style: {
                    fontSize: '12px',
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function (val) {
                    return  NumReplace(val+'') + ' UZS'
                },
            },
        },
        colors: [successColor1, dangerColor2, warningColor3],
        grid: {
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
        markers: {
            strokeColors: labelColor,
            strokeWidth: 3,
        },
    }
}
